import Rails from '@rails/ujs';

export default class BackofficeSatisfactionFormsIndex {
  constructor() {
    this.$modal = $('#bulk-send-modal');
    this.translations = {
      noRecipients: this.$modal.data('no-recipients'),
      error: this.$modal.data('error')
    };
    this.bindEvents();
    this.initializeDatatable();
  }

  bindEvents() {
    $(document).on('click', '#bulk-send-btn', this.bulkSend.bind(this));
    this.$modal.on('hidden.bs.modal', this.resetModal.bind(this));
  }

  initializeDatatable() {
    // Initialize the satisfaction forms datatable with custom sorting
    if ($('#satisfaction-forms-datatable').length > 0) {
      this.datatable = $('#satisfaction-forms-datatable').DataTable({
        language: {
          paginate: {
            previous: "<i class='mdi mdi-chevron-left'>",
            next: "<i class='mdi mdi-chevron-right'>"
          }
        },
        drawCallback: function() {
          $(".dataTables_paginate > .pagination").addClass("pagination-rounded");
        },
        // Default sort by unlocked_at column (index 4) in descending order
        order: [[3, 'desc']]
      });
    }
  }

  parseEmails(text) {
    // Split by newlines, commas, semicolons, or spaces
    const emails = text.split(/[\n,;\s]+/)
      .map(email => email.trim().toLowerCase())
      .filter(email => email && email.includes('@'));
    // Remove duplicates
    return [...new Set(emails)];
  }

  bulkSend() {
    const $btn = $('#bulk-send-btn');
    const url = $btn.data('url');

    const emailsText = $('#bulk-send-emails').val() || '';
    const emails = this.parseEmails(emailsText);
    const templateId = $('#bulk-send-template').val() || '';

    if (emails.length === 0) {
      this.showNotification('error', this.translations.noRecipients);
      return;
    }

    $btn.prop('disabled', true);

    const formData = new FormData();
    emails.forEach(email => formData.append('emails[]', email));
    if (templateId) {
      formData.append('template_id', templateId);
    }

    Rails.ajax({
      url: url,
      type: 'POST',
      data: formData,
      success: (data) => {
        this.$modal.modal('hide');
        this.showNotification('success', data.message);
        setTimeout(() => window.location.reload(), 1500);
      },
      error: (xhr) => {
        let message = this.translations.error;
        try {
          const response = JSON.parse(xhr.response);
          if (response.message) message = response.message;
          if (response.errors && response.errors.length > 0) {
            console.warn('Bulk send errors:', response.errors);
          }
        } catch(e) {
          // Ignore parse errors
        }
        this.showNotification('error', message);
      },
      complete: () => {
        $btn.prop('disabled', false);
      }
    });
  }

  resetModal() {
    $('#bulk-send-emails').val('');
    $('#bulk-send-template').val('');
  }

  showNotification(type, message) {
    if (typeof $.NotificationApp !== 'undefined') {
      $.NotificationApp.send(
        type === 'success' ? 'Succès' : (type === 'warning' ? 'Attention' : 'Erreur'),
        message,
        'top-right',
        'rgba(0,0,0,0.2)',
        type
      );
    } else {
      alert(message);
    }
  }

  onDataChanged(data) {
  }

  onDestroy() {
    $(document).off('click', '#bulk-send-btn');
    this.$modal.off('hidden.bs.modal');
    
    // Destroy the DataTable instance if it exists
    if (this.datatable) {
      this.datatable.destroy();
      this.datatable = null;
    }
  }
}
